var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMessages = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.36,4.5A10.46,10.46,0,0,1,31.6,18.82l-.1.07a5,5,0,0,0,2.16,2.45.41.41,0,0,1-.1.77,6,6,0,0,1-4.44-1.22l0,0A10.49,10.49,0,0,1,24,22.35a12.9,12.9,0,0,0-.91-4.08A13.21,13.21,0,0,0,20.28,14,13.11,13.11,0,0,0,16,11.17a11.06,11.06,0,0,0-2.62-.73A10.54,10.54,0,0,1,16.36,4.5ZM18.6,15.71A10.46,10.46,0,0,1,5.92,32.14l0,0a6,6,0,0,1-4.44,1.23.4.4,0,0,1-.1-.77A5,5,0,0,0,3.5,30.11L3.4,30a10.44,10.44,0,0,1,15.2-14.3ZM7.73,23.09a1.26,1.26,0,1,0-1.26,1.26A1.25,1.25,0,0,0,7.73,23.09Zm4.72,0a1.26,1.26,0,1,0-1.26,1.26A1.25,1.25,0,0,0,12.45,23.09Zm4.68,0a1.26,1.26,0,1,0-1.25,1.26A1.25,1.25,0,0,0,17.13,23.09Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMessages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Messages.40e93332.svg";
export { ForwardRef as ReactComponent };